import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { practiceApi } from "../../lib/practiceApi";

export const QuoteDeleteDialog = ({ row, onClose, onDeleted }) => {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const expected = String(row.client_name || row.recipients || `PREVENTIVO ${row.number || row.id}`).trim();
  async function remove(event) {
    event.preventDefault();
    if (value.trim() !== expected || busy) return;
    setBusy(true); setError("");
    try { await practiceApi(`/estimates/${row.id}`, { method: "DELETE", body: JSON.stringify({ confirm_name: value }) }); await onDeleted(); }
    catch (err) { setError(err.message); } finally { setBusy(false); }
  }
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent className="quote-delete-dialog" data-testid="quote-delete-dialog" closeTestId="quote-delete-close">
      <DialogHeader><DialogTitle>Elimina preventivo n° {row.number}</DialogTitle><DialogDescription>Eliminazione definitiva. La conferma richiede il nome del cliente o della società.</DialogDescription></DialogHeader>
      <form onSubmit={remove}><label htmlFor="quote-delete-name">Digita <strong data-testid="quote-delete-expected">{expected}</strong></label><input id="quote-delete-name" data-testid="quote-delete-name" value={value} onChange={e => setValue(e.target.value)} autoComplete="off" disabled={busy} />
        {error && <p className="error" role="alert" data-testid="quote-delete-error">{error}</p>}
        <div className="practice-inline-actions"><Button type="button" variant="outline" disabled={busy} data-testid="quote-delete-cancel" onClick={onClose}>Annulla</Button><Button type="submit" variant="destructive" disabled={busy || value.trim() !== expected} data-testid="quote-delete-confirm"><Trash2 size={15} />{busy ? "Eliminazione…" : "Elimina definitivamente"}</Button></div>
      </form>
    </DialogContent>
  </Dialog>;
};